import { YOUR_INFO_CLASS_NAMES } from '../constants';

export const PROPS = {
  pageTitle: {
    text: 'Contact Details',
    className: YOUR_INFO_CLASS_NAMES.title,
  },
  email: {
    placeholder: 'Your email address',
    label: '',
    icon: 'lock',
  },
  emailLabel: {
    className: 'w-full text-style-h-em text-neutral-600 mb-2 flex gap-x-1',
  },
  emailLabelLink: {
    className: 'underline cursor-pointer',
  },
  phoneNumber: {
    label: 'Phone',
    placeholder: 'Phone number',
  },
  mobileNumber: {
    placeholder: 'Mobile number',
  },
};

export const TELEPHONE_FIELD_NAME = 'credit.customer_details.telephone';
export const MOBILE_FIELD_NAME = 'credit.customer_details.mobile';
